import { render, staticRenderFns } from "./drawLots-data.vue?vue&type=template&id=8618bea8&scoped=true&"
import script from "./drawLots-data.vue?vue&type=script&lang=js&"
export * from "./drawLots-data.vue?vue&type=script&lang=js&"
import style0 from "./drawLots-data.vue?vue&type=style&index=0&id=8618bea8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8618bea8",
  null
  
)

export default component.exports